module.exports = __webpack_public_path__ + "static/img/bottom1.7946924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bottom1.png
// module id = nKjf
// module chunks = 1